export const Perspective = [
	'Entre 1 et 3 ans',
	'Entre 3 et 5 ans',
	'Entre 5 et 8 ans',
	'Plus de 8 ans'
]

export const Objective = [
	'Protection et valorisation d’un capital existant',
	'Recherche d’un complément de revenus immédiat ou différé',
	'Préparation de votre transmission',
	'Développer mon patrimoine'
]

export const RiskDegree = [
	'Faible risque de perte en capital > potentiel de rendement faible',
	'Risque moyen de perte en capital > potentiel de rendement limité',
	'Risque élevé de perte en capital > potentiel de rendement élevé',
	'Risque important de perte en capital > potentiel de rendement très élevé'
]

export const RisingMarket = [
	'Entre 0% et 5%',
	'Entre 5% et 10%',
	'Entre 10% et 20%',
	'Plus de 20%'
]

export const AssetsEstimate = [
	'A moins de 1 M€',
	'Entre 1 et 2.5 M€',
	'Entre 2,5 et 5 M€',
	'A plus de 5 M€'
]

export const InvestmentEstimate = [
	'Moins de 10%',
	'Entre 10% et 33%',
	'Entre 33% et 50%',
	'Plus de 50%'
]



// WEBPACK FOOTER //
// ./src/common/components/MyPatrimonialLandscape/data/Perspective.js